<template>
    <v-card>
      <v-card-title>
        Cambio de contraseña
        <v-spacer></v-spacer>
      </v-card-title>
      <v-card-text>
        <v-alert color="error" :value="error" icon="close">
          Error en el proceso de cambio de contraseña.
        </v-alert>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-text-field
            counter
            v-model="password" 
            :rules="[rules.required, rules.min, rules.size]" 
            label="Contraseña" 
            prepend-icon="lock" 
            id="inputPass1"
            :type="show1 ? 'text' : 'password'"
            :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="show1 = !show1"
          >
          </v-text-field>
          <v-text-field 
            counter
            v-model="password_confirm"                  
            :rules="[rules.required, passwordConfirmationRule, rules.size]" 
            label="Confirmación"
            prepend-icon="lock" 
            id="inputPass2"
            :type="show2 ? 'text' : 'password'"
            :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="show2 = !show2"
          >
          </v-text-field>
          <v-alert
            border="top"
            colored-border
            type="warning"
            elevation="2"
          >
            <p>La contraseña debe contener:</p>
            <ul>
              <li>Al menos 1 carácter alfabético en minúscula.</li>
              <li>Al menos 1 carácter alfabético en mayúscula.</li>
              <li>Al menos 1 carácter numérico.</li>
              <li>NO caracteres especiales (! @ $ %  & *).</li>
              <li>La contraseña debe tener ocho caracteres o más.</li>
            </ul>
          </v-alert>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <!-- <v-btn :to="{ name: 'login'}" text class="mr-4" color="info">Iniciar Sesión</v-btn> -->
        <v-spacer />
        <v-btn :disabled="!valid" color="primary"  id="register" class="mr-4" @click="validate" >Confirmar</v-btn>
      </v-card-actions>
    </v-card>
</template>
<script>
    import axios from "axios";
    export default {         
    data: function() {
      return {
        valid: true,
        error: false,
        password: '',
        show1: false,
        show2: false,
        password_confirm: '',
        justify: 'center',
        alignment: 'center',
        rules: {
          required: value => !!value || 'Requerido',
          min: v => v.length >= 8 || 'Min 8 caracteres',
          size:  v => /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})(^[A-Za-z0-9]*$)/.test(v) || 'No es una contraseña permitida',
        },
      };
    },
    computed: {
      passwordConfirmationRule() {
        return () => (this.password === this.password_confirm) || 'Contraseñas no coinciden'
      },
    },
    mounted() {
      $("#inputPass1, #inputPass2").keyup(function(event) {
        if (event.keyCode === 13) {
          $("#register").click();
        }
      });
    },
    methods: {
      validate () {
        if (this.$refs.form.validate()) {
          let infoData = {
            "nueva_clave":this.password,
            "confirmacion":this.password_confirm
          };
          this.$store.dispatch('SET_OVERLAY');
          let postPaquete = axios.post('Usuario/cambiar_clave', infoData, { 'headers': this.$store.state.user.headers })
          return postPaquete.then((callback) => 
          {
            console.log(callback);
            this.$store.dispatch('UNSET_OVERLAY');
            if(callback.status == 200)
            {
              this.$router.push({ "name": "logout"});
              this.$store.dispatch('SHOW_ERROR', {show: true, type: 'success', text: 'Cambio realizado con éxito.' });
            } else {
              this.$store.dispatch('SHOW_ERROR', {show: true, type: 'error', text: 'Hubo un error en el proceso.' });
            }
          }).catch((error) => {
            this.$store.dispatch('UNSET_OVERLAY');
            this.$store.dispatch('SHOW_ERROR', {show: true, type: 'error', text: 'Hubo un error en el proceso.' });
            console.log(error);
          });
        }
      },
    },
  };
</script>